<template>
<div class="chapter">
<div class="inner_page">
<p class="p4"><span class="sz"> </span></p>
<p class="p3"><span class="sz"><b>Introduction</b></span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p1"><span class="sz">Introducing Janet Dailey’s AMERICANA. Every novel in this collection is your passport to a romantic tour of the United States through time-honored favorites by America’s First Lady of romance fiction. Each of the fifty novels is set in a different state, researched by Janet and her husband, Bill. For the Daileys it was an odyssey of discovery. For you, it’s the journey of a lifetime.</span></p>
<p class="p2"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section4.vue?2bd03f2a